module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#olympic",
      toString: function () {
        return this.url;
      }
    }